"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartTypeButton = exports.ChartBoxTypePicker = void 0;
const ChartType_1 = __importDefault(require("@opsbase/lib-chart/ChartType"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useViewActions_1 = __importDefault(require("@opsbase/web-ctrl-view/useViewActions"));
const AreaChartIcon_1 = __importDefault(require("@opsbase/web-icons/icons/AreaChartIcon"));
const BarChartIcon_1 = __importDefault(require("@opsbase/web-icons/icons/BarChartIcon"));
const PieChartIcon_1 = __importDefault(require("@opsbase/web-icons/icons/PieChartIcon"));
const StackChartIcon_1 = __importDefault(require("@opsbase/web-icons/icons/StackChartIcon"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const IconButton_1 = __importDefault(require("@opsbase/web-ui/IconButton"));
const react_1 = __importStar(require("react"));
const makeMyClasses = () => ({
    root: {
        minWidth: 20,
        maxWidth: 20,
        position: 'absolute',
        top: 4,
        right: 4,
    },
});
function ChartBoxTypePicker(props) {
    const { chart, options = [] } = props;
    const dt = (0, useDataTree_1.default)();
    const { updateChart } = (0, useViewActions_1.default)(dt.viewId);
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const handleChange = (0, useCallforward_1.default)(chartType => () => {
        updateChart(Object.assign(Object.assign({}, chart), { chartType }));
    }, [chart, updateChart]);
    return (0, react_1.useMemo)(() => {
        if (!options.length)
            return null;
        return (react_1.default.createElement(Vertical_1.default, { shrink: true, classes: { root: myCss.root }, justify: "flex-start" }, options.map(chartType => (react_1.default.createElement(ChartTypeButton, { key: 'toggle' + chartType, selected: chart.chartType === chartType, type: chartType, onClick: handleChange(chartType) })))));
    }, [options, myCss, chart.chartType, handleChange]);
}
exports.ChartBoxTypePicker = ChartBoxTypePicker;
exports.default = ChartBoxTypePicker;
function ChartTypeButton({ selected = false, type, onClick }) {
    const iconProps = (0, react_1.useMemo)(() => ({
        size: 12,
        color: selected ? lib_palette_1.default.secondary : lib_palette_1.default.GreyBlue,
    }), [selected]);
    const buttonStyle = (0, react_1.useMemo)(() => ({
        marginBottom: 4,
        backgroundColor: selected ? lib_palette_1.default.LightBlue.main : lib_palette_1.default.BackgroundGrey.main,
    }), [selected]);
    const icon = (0, react_1.useMemo)(() => {
        switch (type) {
            case ChartType_1.default.BAR3DSTACK:
                return react_1.default.createElement(StackChartIcon_1.default, Object.assign({}, iconProps));
            case ChartType_1.default.AREA3DSTACK:
                return react_1.default.createElement(AreaChartIcon_1.default, Object.assign({}, iconProps));
            case ChartType_1.default.PIE2D:
                return react_1.default.createElement(PieChartIcon_1.default, Object.assign({}, iconProps));
            case ChartType_1.default.BAR3DGROUP:
            case ChartType_1.default.BAR2D:
            default:
                return react_1.default.createElement(BarChartIcon_1.default, Object.assign({}, iconProps));
        }
    }, [iconProps, type]);
    return (react_1.default.createElement(IconButton_1.default, { size: 20, style: buttonStyle, disabled: selected, icon: icon, onClick: onClick }));
}
exports.ChartTypeButton = ChartTypeButton;
